module.exports = __webpack_public_path__ + "img/a2.9fcac8f9.webp";